import { makeVar, gql } from '@apollo/client'
import { User } from '../entity/User'

export const getUserVar = makeVar({})

export const readGetUserVar = {
  read() {
    return getUserVar()
  },
}

export const GET_USER_VAR = gql`
  query GetUser {
    user @client
  }
`

export const getLoggedInUser = gql`
  query User($id: Int!) {
    user(id: $id) ${User}
  }
`
